import { ResourceOptions } from 'react-admin';
import { FaSearch } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.hotSearch;
export const icon = FaSearch;
export const options: ResourceOptions = {
  label: 'resource.hot-search',
};






